import { LayoutGrid } from 'lucide-react';
import { engagementPath } from '../engagementPaths';
import { NATURALS_PARTNER_OPS_APPOINTMENTS } from '../engagementPortal';
import { getEngagementSections } from './navConfig';

const PARTNER_BASE = '/naturals/partner';
const WORKSPACE_BASE = '/naturals/workspace';
const PARTNER_ENGAGEMENT_PREFIX = `${PARTNER_BASE}/engagement`;
const WORKSPACE_ENGAGEMENT_PREFIX = `${WORKSPACE_BASE}/engagement`;

export function isPartnerEngagementPath(pathname) {
  const p = String(pathname || '');
  return p === PARTNER_ENGAGEMENT_PREFIX || p.startsWith(`${PARTNER_ENGAGEMENT_PREFIX}/`);
}

export function isWorkspaceEngagementPath(pathname) {
  const p = String(pathname || '');
  return p === WORKSPACE_ENGAGEMENT_PREFIX || p.startsWith(`${WORKSPACE_ENGAGEMENT_PREFIX}/`);
}

function buildPortalEngagementSidebarItems(portal, counts = {}) {
  const homeBase = portal === 'workspace' ? WORKSPACE_BASE : PARTNER_BASE;
  const sections = getEngagementSections(portal);
  const items = [
    {
      key: 'overview',
      sectionId: 'overview',
      IconComponent: LayoutGrid,
      label: 'Back to main',
      to: `${homeBase}/overview`,
    },
  ];

  sections.forEach((section) => {
    section.items.forEach((item) => {
      const to =
        portal === 'partner' && item.segment === 'appointments'
          ? NATURALS_PARTNER_OPS_APPOINTMENTS
          : engagementPath(item.segment);
      items.push({
        key: `engagement-${item.segment || 'home'}`,
        sectionId: section.sectionId,
        IconComponent: item.IconComponent,
        label: `${item.label}${badgeSuffix(counts, item.badge)}`,
        to,
        activeMatchPaths: [to, `${to}/`],
        exactActive: Boolean(item.end),
      });
    });
  });

  return items;
}

function badgeSuffix(counts, badgeKey) {
  if (!badgeKey || !(counts[badgeKey] > 0)) return '';
  return ` (${counts[badgeKey]})`;
}

/** Partner portal sidebar when viewing /naturals/partner/engagement/* */
export function buildPartnerEngagementSidebarItems(pathname, counts = {}) {
  return buildPortalEngagementSidebarItems('partner', counts);
}

/** Workspace HQ sidebar when viewing /naturals/workspace/engagement/* */
export function buildWorkspaceEngagementSidebarItems(pathname, counts = {}) {
  return buildPortalEngagementSidebarItems('workspace', counts);
}
